import { PaddingState } from '../../common/types/padding/PaddingState';

export type DividerState = PaddingState & {};
